import * as actions from '../../utils/Actions';
import { notUndefinedAndNull } from '../../utils/Validation';

const initialState = {
    showPageLoader: false,
    forms: [],
    defaultFormData: null,
    formStructureData: null,
    paydirectStandardDivisionData : [],
    stateList : [],
    districtList : [],
    studentUpdateResponse : null,
    studentDetails : null,
    filterDropDownValue : [],
    customFieldDropdownValue : []
}

export default function paydirect(state = initialState, action){

    if(typeof state === 'undefined'){
        return state;
    }

    switch (action.type){

        case actions.RESETE_PAYDIRECT_DATA:
            return {
              ...state,
              studentUpdateResponse: null,
            };

        case actions.RESET_REGISTRATION_UPDATE_DATA:
            return {
              ...state,
              studentUpdateResponse: null,
            };

            
        case actions.pending(actions.GET_FORM_LIST):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_FORM_LIST):
            return {
                ...state,
                showPageLoader: false,
                forms: action.payload.data
            }

        case actions.rejected(actions.GET_FORM_LIST):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_DEFAULT_FORM):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_DEFAULT_FORM):
            return {
                ...state,
                showPageLoader: false,
                defaultFormData: action.payload.data
            }

        case actions.rejected(actions.GET_DEFAULT_FORM):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_FORM_STRUCTURE):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_FORM_STRUCTURE):
            return {
                ...state,
                showPageLoader: false,
                formStructureData: action.payload.data
            }

        case actions.rejected(actions.GET_FORM_STRUCTURE):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_STANDARD_DIVISION_CAST):
            return {
                ...state,
                showPageLoader : true
            }

        case actions.fulfilled(actions.GET_STANDARD_DIVISION_CAST):
            let standardDivisionData = action.payload.data;
            let paydirectStandardDivisionData = notUndefinedAndNull(standardDivisionData) ? standardDivisionData: null;
            return {
                ...state,
                paydirectStandardDivisionData : paydirectStandardDivisionData,
                showPageLoader : false
            }

        case actions.rejected(actions.GET_STANDARD_DIVISION_CAST):
            return {
                ...state,
                showPageLoader : false
            }

        case actions.pending(actions.GET_STATE_LIST):
            return {
                ...state,
                showPageLoader : true
            }

        case actions.fulfilled(actions.GET_STATE_LIST):
            let states = action.payload.data;
            let stateList = ( notUndefinedAndNull(states) && states.length > 0 ) ? states: null;
            return {
                ...state,
                stateList : stateList,
                showPageLoader : false
            }

        case actions.rejected(actions.GET_STATE_LIST):
            return {
                ...state,
                showPageLoader : false
            }

        case actions.pending(actions.GET_DISTRICT_LIST):
            return {
                ...state,
            }

        case actions.fulfilled(actions.GET_DISTRICT_LIST):
            let district = action.payload.data;
            let districtList = ( notUndefinedAndNull(district) && district.length > 0 ) ? district: null;
            return {
                ...state,
                districtList : districtList,
                showPageLoader : false
            }

        case actions.rejected(actions.GET_DISTRICT_LIST):
            return {
                ...state,
                showPageLoader : false
            }

        case actions.pending(actions.SAVE_STUDENT):
            return {
                ...state,
                showPageLoader : true
            }

        case actions.fulfilled(actions.SAVE_STUDENT):
            return {
                ...state,
                studentDetails: action.meta,
                studentUpdateResponse : action.payload.data,
                showPageLoader : false
            }

        case actions.rejected(actions.SAVE_STUDENT):
            return {
                ...state,
                showPageLoader : false
            }

        case actions.pending(actions.GET_FILTER_DROPDOWN_VALUE):
            return {
                ...state,
                showPageLoader : true
            }

        case actions.fulfilled(actions.GET_FILTER_DROPDOWN_VALUE):
            return {
                ...state,
                filterDropDownValue : action.payload.data,
                showPageLoader : false
            }

        case actions.rejected(actions.GET_FILTER_DROPDOWN_VALUE):
            return {
                ...state,
                showPageLoader : false
            }

        case actions.pending(actions.GET_CUSTOM_FIELD_DROPDOWN_VALUE):
            return {
                ...state,
                showPageLoader : true
            }

        case actions.fulfilled(actions.GET_CUSTOM_FIELD_DROPDOWN_VALUE):
            return {
                ...state,
                customFieldDropdownValue : action.payload.data,
                showPageLoader : false
            }

        case actions.rejected(actions.GET_CUSTOM_FIELD_DROPDOWN_VALUE):
            return {
                ...state,
                showPageLoader : false
            }

        default : 
            return {...state}
    }

}